import { State } from 'model/State';
import { getFromHamsClient } from 'util/mac/api/genericProperty/get';
import { fetchWithParamValidation } from 'util/fetchWithParamValidation';

export const genericProperty = (fullKey: string, state: State) =>
  fetchWithParamValidation(({ key }) => getFromHamsClient(`/${key}`, state), {
    key: fullKey,
  });
